import { SVGProps } from 'react';

const IcNext = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
    <path
      d='M5.33335 14C5.13335 14 5.00002 13.9333 4.86669 13.8C4.60002 13.5333 4.60002 13.1333 4.86669 12.8667L9.73335 8L4.86669 3.13333C4.60002 2.86667 4.60002 2.46667 4.86669 2.2C5.13335 1.93333 5.53335 1.93333 5.80002 2.2L11.1334 7.53333C11.4 7.8 11.4 8.2 11.1334 8.46667L5.80002 13.8C5.66669 13.9333 5.53335 14 5.33335 14Z'
      fill='white'
    />
  </svg>
);

export default IcNext;
